import React, { useState } from "react";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

const LABELS = { requested: "Pending confirmation", confirmed: "Active", revoked: "Off" };

export const SmsConsentRow = ({ kind, title, text, consent, fallbackPhone, onUser }) => {
  const [confirming, setConfirming] = useState(false);
  const [phone, setPhone] = useState("");
  const [busy, setBusy] = useState(false);
  const on = !!consent && consent.status !== "revoked";
  const needsPhone = !fallbackPhone;

  const call = async (path, body) => {
    setBusy(true);
    try {
      const { data } = await api.post(path, body);
      onUser(data.user);
      setConfirming(false);
      toast.success(body ? "Consent recorded." : "Turned off.");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  const toggle = (v) => {
    if (v) { setConfirming(true); } else { call(`/auth/sms-consent/opt-out?kind=${kind}`); }
  };

  return (
    <div className="py-4 first:pt-0 last:pb-0" data-testid={`sms-consent-row-${kind}`}>
      <div className="flex items-center justify-between gap-4">
        <div>
          <p className="text-sm font-semibold">{title}</p>
          <p className="text-xs text-ink-muted" data-testid={`sms-consent-status-${kind}`}>
            {consent ? LABELS[consent.status] || consent.status : "Not subscribed"}
            {consent?.phone ? ` · ${consent.phone}` : ""}
          </p>
        </div>
        <Switch checked={on || confirming} onCheckedChange={toggle} disabled={busy}
          data-testid={`sms-consent-switch-${kind}`} />
      </div>
      {confirming && (
        <div className="mt-3 rounded-xl bg-oatmeal/60 p-3 space-y-3" data-testid={`sms-consent-confirm-${kind}`}>
          <p className="text-xs leading-relaxed text-espresso-soft">{text}</p>
          {needsPhone && (
            <Input type="tel" placeholder="(555) 012-3456" value={phone} onChange={(e) => setPhone(e.target.value)}
              data-testid={`sms-consent-phone-${kind}`} />
          )}
          <div className="flex gap-2">
            <Button size="sm" disabled={busy} onClick={() => call("/auth/sms-consent/opt-in", { kind, phone: needsPhone ? phone : null })}
              data-testid={`sms-consent-agree-${kind}`}>I agree</Button>
            <Button size="sm" variant="outline" onClick={() => setConfirming(false)}
              data-testid={`sms-consent-cancel-${kind}`}>Cancel</Button>
          </div>
        </div>
      )}
    </div>
  );
};
